import React from 'react'
import PropTypes from 'prop-types'
import styles from './QuestionBlock.css'
import ComponentBuilder from '../../archetypes/ComponentBuilder'
import ValidationError from '@healthwise-ui/core/ValidationError'
import { getKey } from '@healthwise-ui/core/KeyGen'

class QuestionBlock extends React.Component {
  render () {
    let { children, question, questionId, questionNumber, requiredNotice, isRequired, validationErrorText, ...otherAttributes } = this.props

    let questionNumberElement, requiredNoticeElement, requiredIndicator, validationError
    if (questionNumber) {
      questionNumberElement = (
        <span className="hw-question-number">
          <span className="hw-question-number-value">{questionNumber}</span>
          <span className="hw-question-dot">. </span>
        </span>
    )
    }

    let questionElement = question
    if (/^<div(.+)div>$/.test(question)) {
      const componentBuilder = new ComponentBuilder({
        componentMap: [
          {
            when: (node) => { return node && (node.tagName || '').toLowerCase() === 'div' },
            use: 'span',
            withProps: { className: 'hw-question-text' }
          }
        ]
      })
      questionElement = componentBuilder.build(question)
    } else {
      questionElement = (new ComponentBuilder()).build(`<span class='hw-question-text'>${question}</span>`)
    }

    let localClassName = 'hw-question '
    if (isRequired) {
      requiredNoticeElement = (<span className={styles.common_hidden_text} >{requiredNotice}</span>)
      requiredIndicator = (<span aria-hidden="true" className={'hw-question-required-indicator ' + styles.question_is_required_indicator + (isRequired ? ' ' + styles.question_is_required : '')}>*</span>)
      localClassName += 'hw-required '
      if (validationErrorText) {
        localClassName += styles.invalid
        validationError = (<ValidationError forId={questionId} >{validationErrorText}</ValidationError>)
      }
    }

    return (
      <fieldset className={'hw-question-block ' + styles.question_block} {...otherAttributes}>
        <legend
          className={localClassName + styles.question}
          data-hw-qnumber={questionNumber}
          data-hw-qid={questionId}
          id={questionId}
          {...otherAttributes} >
          {validationError}
          {requiredIndicator}
          {requiredNoticeElement}
          {questionNumberElement}
          {questionElement}
        </legend>
        {children}
      </fieldset>
    )
  }
}

QuestionBlock.propTypes = {
  children: PropTypes.node.isRequired,
  requiredNotice: PropTypes.string,
  validationErrorText: PropTypes.string,
  question: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  questionId: PropTypes.string,
  isRequired: PropTypes.bool,
  questionNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

QuestionBlock.defaultProps = {
  questionId: getKey(),
  requiredNotice: 'required question',
  isRequired: false
}

export default QuestionBlock



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/QuestionBlock/index.js